module.exports = __webpack_public_path__ + "static/media/photo-14.d4bbd5de.jpg";